import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, VoucherService } from '../../services';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useNavigate } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import VoucherUtilization from './VoucherUtilization';
import { EditIcon, LeftArrowIcon } from '../../components/icons/IconProvider';
import CopyToClipboardText from '../../components/CopyToClipboardText';
import { ConfigService } from '../../services';
import StatusBadge from '../../components/StatusBadge';

const ProjectDetails = () => {
  let params = useParams();
  const navigate = useNavigate();
  let projectId = params ? params.id : null;
  const [voucherDetails, setVoucherDetails] = useState([]);
  const [isDetailsLoader, setDetailsLoader] = useState(true);
  const [setConfirmationPopData] = useState({
    FirstText: '',
    SecondText: '',
    FirstButton: '',
    secondButton: '',
    slug: '',
  });

  useEffect(() => {
    getVoucherDetail();
  }, []);

  async function getVoucherDetail() {
    try {
      const response = await VoucherService.getVoucherDetails(projectId);

      if (response.data) {
        setVoucherDetails(response.data);
        setDetailsLoader(false);
      } else {
        navigate('/vouchers/list');
      }
    } catch (error) {
      Alert.error(error.message);
    }
  }

  const editVoucherRedirect = (voucherId) => {
    if (voucherDetails.project_status === 1) {
      setConfirmationPopData({
        FirstText: 'Warning',
        SecondText:
          'In order to edit the project page, you must first Unpublish the project.',
        FirstButton: 'Cancel',
        secondButton: 'Unpublish',
        slug: 'unpublish',
      });
      return false;
    }
    navigate('/vouchers/addedit/' + voucherId);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/vouchers/list')}
            className="w-11 h-11 flex items-center justify-center mr-3 text-brandBlue p-0"
          >
            <LeftArrowIcon />
          </button>
          <h4 className="">Voucher Details</h4>
        </div>
        <button
          onClick={() => editVoucherRedirect(projectId)}
          disabled={voucherDetails?.totalTokenUtilized !== 0}
          className={`  inline-flex items-center text-sm mb-3 md:mb-0 ${voucherDetails?.totalTokenUtilized !== 0 ? 'cursor-not-allowed bg-[#787a7d] border-[#787a7d] text-white' : 'bg-brandBlue font-semibold text-white border  border-brandBlue'}`}
        >
          <EditIcon />
          Edit Voucher
        </button>
      </div>
      <div className="">
        <div>
          <div className="flex items-center justify-between w-full"></div>
          {isDetailsLoader && (
            <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
              <Skeleton count={1} height={400} />
              <div className="p-4 grid grid-cols-4 gap-8 w-full bg-gray-50 rounded-xl mt-4">
                {[...Array(4)].map((_, index) => (
                  <Skeleton key={index} count={1} height={60} />
                ))}
              </div>
            </SkeletonTheme>
          )}
        </div>

        <div>
          {isDetailsLoader === false && (
            <div>
              <div className="border-b border-bordercolor pb-3 mb-3 mt-4">
                <div className="flex gap-8">
                  <h3 className="text-3xl font-semibold leading-normal">
                    {voucherDetails?.project.name || '--'}{' '}
                    {voucherDetails?.project.symbol &&
                      `(${voucherDetails?.project.symbol})`}
                  </h3>
                </div>
              </div>
              <div className="w-full bg-brandGray px-5 py-4 rounded-xl mb-4">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3.5">
                  <div>
                    <label className="text-sm">Voucher Code</label>
                    <div className="flex items-center justify-start gap-4">
                      <p className="font-semibold">
                        {' '}
                        {voucherDetails?.voucher_code.replace(/["']/g, '') ||
                          '0'}
                      </p>
                      {voucherDetails?.voucher_code && (
                        <CopyToClipboardText
                          text={voucherDetails?.voucher_code}
                          copyMessage={'Voucher Code Copied!'}
                        />
                      )}
                    </div>
                  </div>

                  <div>
                    <label className="text-sm">Token Alloted </label>
                    <p className="font-semibold">
                      {' '}
                      {voucherDetails?.token_alloted || '0'}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm">Expiry Date </label>
                    <div className="flex items-center font-semibold">
                      {ConfigService.dateFormat(
                        voucherDetails?.expiry_date,
                        false,
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="text-sm">Total Tokens Utilized</label>
                    <p className="font-semibold">
                      {' '}
                      {voucherDetails?.totalTokenUtilized || 0}
                    </p>
                  </div>
                  <div className="">
                    <label className="text-sm">Status</label>
                    <div>
                      <StatusBadge
                        status={
                          voucherDetails.is_active === 1 ? 'active' : 'inactive'
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="col-span-2 mt-5">
          <div className="bg-brandGray p-5 rounded-lg w-full ">
            <div className="grid md:grid-cols-2 gap-4 mb-4 border-b border-[#B6BDC5]">
              <div>
                <h3 className="">Tokens Utilization</h3>
                <p></p>
              </div>
            </div>

            <VoucherUtilization />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProjectDetails;
